import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useScreen } from '../lib/useScreen';
import { useAuth } from '../lib/AuthProvider';
import { supabase } from '../lib/supabaseClient';
import { ParticlesCanvas } from '../components/landing';

const font = "'DM Sans', sans-serif";
const serif = "'DM Serif Display', serif";
const C = {
  turquesa: '#5dc1b9',
  mango: '#FDBE02',
  coral: '#eb636b',
  morado: '#534AB7',
  lila: '#AFA9EC',
  verde: '#1D9E75',
  dark: '#0a0a0a',
};

const glass = {
  background: 'rgba(255,255,255,0.03)',
  border: '0.5px solid rgba(255,255,255,0.08)',
  borderRadius: 20,
};

export default function QueEsPKM() {
  const navigate = useNavigate();
  const { isMobile } = useScreen();
  const { user } = useAuth();
  const mob = isMobile;

  const handleCTA = () => {
    if (user) {
      navigate('/sala');
    } else {
      supabase.auth.signInWithOAuth({
        provider: 'google',
        options: { redirectTo: window.location.origin + '/dashboard' },
      });
    }
  };

  return (
    <div style={{ fontFamily: font, color: '#fff', background: C.dark, minHeight: '100vh', position: 'relative', overflow: 'hidden' }}>
      {/* Particles */}
      <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, zIndex: 0 }}>
        <ParticlesCanvas />
      </div>

      {/* NAV-BACK pill */}
      <nav style={{ position: 'fixed', top: 16, left: 16, zIndex: 100 }}>
        <button
          onClick={() => navigate('/')}
          style={{
            background: 'rgba(10,10,10,0.6)',
            backdropFilter: 'blur(16px)',
            WebkitBackdropFilter: 'blur(16px)',
            border: '0.5px solid rgba(255,255,255,0.12)',
            borderRadius: 50,
            padding: '8px 18px',
            color: 'rgba(255,255,255,0.7)',
            fontSize: 13,
            fontWeight: 500,
            cursor: 'pointer',
            fontFamily: font,
            transition: 'border-color 0.3s, color 0.3s',
          }}
          onMouseEnter={e => { e.currentTarget.style.borderColor = 'rgba(93,193,185,0.4)'; e.currentTarget.style.color = '#fff'; }}
          onMouseLeave={e => { e.currentTarget.style.borderColor = 'rgba(255,255,255,0.12)'; e.currentTarget.style.color = 'rgba(255,255,255,0.7)'; }}
        >
          ← Volver
        </button>
      </nav>

      {/* CONTENT */}
      <div style={{ position: 'relative', zIndex: 1, maxWidth: 1100, margin: '0 auto', padding: mob ? '80px 16px 60px' : '100px 24px 80px' }}>

        {/* ═══ 1. HERO ═══ */}
        <section style={{ textAlign: 'center', marginBottom: mob ? 60 : 80 }}>
          <span style={{
            display: 'inline-block', padding: '5px 14px', borderRadius: 50,
            background: 'rgba(93,193,185,0.12)', color: C.turquesa,
            fontSize: 11, fontWeight: 600, letterSpacing: 2, textTransform: 'uppercase',
            marginBottom: 20,
          }}>
            ¿QUE ES?
          </span>

          <h1 className="td-hero-grad" style={{
            fontFamily: serif, fontSize: mob ? 32 : 56, fontWeight: 400,
            lineHeight: 1.15, margin: '0 0 24px',
          }}>
            Gestion de{mob ? <br /> : ' '}Conocimiento Personal
          </h1>

          <p style={{
            fontSize: mob ? 15 : 18, color: 'rgba(255,255,255,0.6)',
            lineHeight: 1.8, maxWidth: 640, margin: '0 auto',
          }}>
            Un sistema para capturar, organizar y conectar la informacion que vas acumulando: notas, ideas, aprendizajes, referencias. No pierdas lo que aprendes, conectalo para que sea util cuando lo necesites.
          </p>
        </section>

        {/* ═══ 2. PARA QUE SIRVE — 4 cards ═══ */}
        <section style={{ marginBottom: mob ? 60 : 80 }}>
          <div style={{ textAlign: 'center', marginBottom: 32 }}>
            <span style={{ fontSize: 11, color: C.turquesa, fontWeight: 600, letterSpacing: 2, textTransform: 'uppercase' }}>PARA QUE SIRVE</span>
            <p style={{ fontFamily: serif, fontSize: mob ? 22 : 28, fontWeight: 400, margin: '8px 0 0', color: '#fff' }}>4 razones que cambian todo</p>
          </div>

          <div style={{
            display: 'grid',
            gridTemplateColumns: `repeat(auto-fit, minmax(${mob ? '100%' : '220px'}, 1fr))`,
            gap: 16,
          }}>
            {[
              { emoji: '🧠', title: 'No dependas de tu memoria', desc: 'Recuerda y encuentra info sin tener que retenerlo todo en la cabeza.' },
              { emoji: '🔗', title: 'Conecta lo no relacionado', desc: 'Las ideas que parecian sueltas se enlazan y dan a luz ideas nuevas.' },
              { emoji: '✍️', title: 'Piensa mejor al escribir', desc: 'Escribir te obliga a aclarar que entiendes y que no. Ahi esta el oro.' },
              { emoji: '📈', title: 'Conocimiento que crece', desc: 'No se queda estatico. Crece con el tiempo, contigo, en capas.' },
            ].map((c, i) => (
              <div key={i} style={{
                ...glass, padding: mob ? '24px 20px' : '28px 24px',
                transition: 'transform 0.3s, border-color 0.3s',
              }}
                onMouseEnter={e => { e.currentTarget.style.transform = 'translateY(-2px)'; e.currentTarget.style.borderColor = 'rgba(93,193,185,0.3)'; }}
                onMouseLeave={e => { e.currentTarget.style.transform = 'translateY(0)'; e.currentTarget.style.borderColor = 'rgba(255,255,255,0.08)'; }}
              >
                <div style={{ fontSize: 32, marginBottom: 12 }}>{c.emoji}</div>
                <p style={{ fontSize: 15, fontWeight: 600, color: '#fff', margin: '0 0 8px' }}>{c.title}</p>
                <p style={{ fontSize: 14, color: 'rgba(255,255,255,0.55)', lineHeight: 1.7, margin: 0 }}>{c.desc}</p>
              </div>
            ))}
          </div>
        </section>

        {/* ═══ 3. ZETTELKASTEN METHOD BOX ═══ */}
        <section style={{ marginBottom: mob ? 60 : 80 }}>
          <div style={{
            background: 'linear-gradient(135deg, rgba(83,74,183,0.12), rgba(93,193,185,0.08))',
            border: '1px solid rgba(175,169,236,0.3)',
            borderRadius: 24,
            padding: mob ? '32px 20px' : '40px 40px',
            textAlign: 'center',
            maxWidth: 720,
            margin: '0 auto',
          }}>
            <span style={{ fontSize: 11, color: C.lila, fontWeight: 600, letterSpacing: 2, textTransform: 'uppercase' }}>EL METODO</span>
            <h2 style={{ fontFamily: serif, fontSize: mob ? 28 : 32, fontWeight: 400, margin: '8px 0 20px', color: '#fff' }}>Zettelkasten</h2>
            <p style={{ fontSize: mob ? 15 : 16, color: 'rgba(255,255,255,0.65)', lineHeight: 1.8, margin: '0 0 20px' }}>
              El metodo mas conocido para la Gestion de Conocimiento Personal: notas atomicas (una idea por nota) que se enlazan unas con otras formando una red viva. T&D aplica esta logica con dos espacios distintos.
            </p>
            <p style={{ fontSize: mob ? 14 : 15, color: C.lila, fontStyle: 'italic', margin: 0 }}>
              "De ahi salen las Ideas Atomicas y los Pensamientos Atomicos."
            </p>
          </div>
        </section>

        {/* ═══ 4. DOS ESPACIOS ═══ */}
        <section style={{ marginBottom: mob ? 60 : 80 }}>
          <div style={{ textAlign: 'center', marginBottom: 32 }}>
            <span style={{ fontSize: 11, color: C.turquesa, fontWeight: 600, letterSpacing: 2, textTransform: 'uppercase' }}>LOS DOS ESPACIOS DE T&D</span>
            <p style={{ fontFamily: serif, fontSize: mob ? 20 : 26, fontWeight: 400, margin: '8px 0 0', color: '#fff' }}>
              Privado para madurar. <span style={{ color: 'rgba(255,255,255,0.3)' }}>/</span> Publico para conectar.
            </p>
          </div>

          <div style={{ display: 'grid', gridTemplateColumns: mob ? '1fr' : '1fr 1fr', gap: 20 }}>
            {/* IDEAS ATOMICAS */}
            <div style={{
              background: 'linear-gradient(180deg, rgba(83,74,183,0.15), rgba(83,74,183,0.05))',
              border: '1px solid rgba(83,74,183,0.3)',
              borderRadius: 24,
              padding: mob ? '28px 20px' : '32px 28px',
            }}>
              <div style={{ fontSize: 48, marginBottom: 12 }}>🧠</div>
              <h3 style={{ fontFamily: serif, fontSize: 22, fontWeight: 400, margin: '0 0 6px', color: '#fff' }}>Ideas Atomicas</h3>
              <p style={{ fontSize: 13, color: C.lila, fontWeight: 500, margin: '0 0 12px' }}>Tu gestor personal · piensa solo para ti</p>
              <span style={{
                display: 'inline-block', padding: '4px 12px', borderRadius: 50,
                background: 'rgba(253,190,2,0.15)', color: C.mango,
                fontSize: 11, fontWeight: 600, marginBottom: 16,
              }}>🔒 Doer $139/mes</span>

              <p style={{ fontSize: 14, color: 'rgba(255,255,255,0.7)', lineHeight: 1.7, margin: '0 0 12px' }}>
                Aqui piensas tu proyecto solo para ti.
              </p>
              <p style={{ fontSize: 14, color: 'rgba(255,255,255,0.6)', lineHeight: 1.7, margin: '0 0 12px' }}>
                Es tu Gestion de Conocimiento Personal: el lugar donde guardas ideas, conceptos y planes que estas madurando para tu propio proyecto.
              </p>
              <p style={{ fontSize: 14, color: 'rgba(255,255,255,0.6)', lineHeight: 1.7, margin: '0 0 20px' }}>
                Nadie las ve. No tienen que estar perfectas. No estan "publicadas". Es tu cuaderno mental privado donde piensas en voz baja, sin presion, a tu ritmo.
              </p>

              {/* Ejemplos box */}
              <div style={{ background: 'rgba(0,0,0,0.3)', borderRadius: 14, padding: mob ? '16px 14px' : '20px 18px' }}>
                <p style={{ fontSize: 10, color: C.lila, fontWeight: 600, letterSpacing: 1.5, textTransform: 'uppercase', margin: '0 0 10px' }}>EJEMPLOS</p>
                {[
                  'Posible modelo de negocio para mi marca de tacos',
                  'Combo familiar de 4 personas $250',
                  'Investigar como cobra Pizza Hut por delivery',
                  'Mi hermano podria ser socio si pongo $X',
                ].map((ex, i) => (
                  <p key={i} style={{ fontSize: 13, color: 'rgba(255,255,255,0.55)', margin: '0 0 6px', display: 'flex', gap: 8 }}>
                    <span style={{ color: C.lila, flexShrink: 0 }}>→</span>{ex}
                  </p>
                ))}
                <p style={{ fontSize: 12, color: 'rgba(255,255,255,0.35)', fontStyle: 'italic', margin: '10px 0 0' }}>
                  Estas ideas son tuyas. Sobre tu proyecto. Nadie mas las ve.
                </p>
              </div>
            </div>

            {/* PENSAMIENTOS ATOMICOS */}
            <div style={{
              background: 'linear-gradient(180deg, rgba(93,193,185,0.15), rgba(93,193,185,0.05))',
              border: '1px solid rgba(93,193,185,0.3)',
              borderRadius: 24,
              padding: mob ? '28px 20px' : '32px 28px',
            }}>
              <div style={{ fontSize: 48, marginBottom: 12 }}>🌐</div>
              <h3 style={{ fontFamily: serif, fontSize: 22, fontWeight: 400, margin: '0 0 6px', color: '#fff' }}>Pensamientos Atomicos</h3>
              <p style={{ fontSize: 13, color: C.turquesa, fontWeight: 500, margin: '0 0 12px' }}>La red de la comunidad · piensa con otros</p>
              <span style={{
                display: 'inline-block', padding: '4px 12px', borderRadius: 50,
                background: 'rgba(29,158,117,0.15)', color: C.verde,
                fontSize: 11, fontWeight: 600, marginBottom: 16,
              }}>🌍 Free Observer en adelante</span>

              <p style={{ fontSize: 14, color: 'rgba(255,255,255,0.7)', lineHeight: 1.7, margin: '0 0 12px' }}>
                Aqui piensas con la comunidad sobre temas en comun.
              </p>
              <p style={{ fontSize: 14, color: 'rgba(255,255,255,0.6)', lineHeight: 1.7, margin: '0 0 12px' }}>
                Son reflexiones, observaciones o preguntas sobre temas que afectan a todos los emprendedores: como cobrar, cerrar una venta, contratar, lidiar con incertidumbre.
              </p>
              <p style={{ fontSize: 14, color: 'rgba(255,255,255,0.6)', lineHeight: 1.7, margin: '0 0 20px' }}>
                NO son sobre tu proyecto especifico. Son sobre temas universales que la comunidad puede discutir y conectar.
              </p>

              {/* Ejemplos box */}
              <div style={{ background: 'rgba(0,0,0,0.3)', borderRadius: 14, padding: mob ? '16px 14px' : '20px 18px' }}>
                <p style={{ fontSize: 10, color: C.turquesa, fontWeight: 600, letterSpacing: 1.5, textTransform: 'uppercase', margin: '0 0 10px' }}>EJEMPLOS</p>
                {[
                  'Cobrar por valor vs por hora cambia todo el negocio',
                  'El primer cliente nunca es el ideal',
                  'Validar antes de construir te ahorra meses',
                  'El miedo de cerrar la venta es del que vende',
                ].map((ex, i) => (
                  <p key={i} style={{ fontSize: 13, color: 'rgba(255,255,255,0.55)', margin: '0 0 6px', display: 'flex', gap: 8 }}>
                    <span style={{ color: C.turquesa, flexShrink: 0 }}>→</span>{ex}
                  </p>
                ))}
                <p style={{ fontSize: 12, color: 'rgba(255,255,255,0.35)', fontStyle: 'italic', margin: '10px 0 0' }}>
                  Son sobre temas, no proyectos. Otros los conectan con los suyos.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* ═══ 5. WIKILINKS ═══ */}
        <section style={{
          background: 'rgba(255,255,255,0.02)',
          borderRadius: 20,
          padding: mob ? '36px 20px' : '48px 36px',
          textAlign: 'center',
          marginBottom: mob ? 60 : 80,
        }}>
          <h2 style={{ fontFamily: serif, fontSize: mob ? 22 : 28, fontWeight: 400, margin: '0 0 16px', color: '#fff' }}>¿Como se conectan?</h2>
          <p style={{ fontSize: mob ? 14 : 16, color: 'rgba(255,255,255,0.6)', lineHeight: 1.7, maxWidth: 560, margin: '0 auto 28px' }}>
            Usas <span style={{ color: C.turquesa, fontWeight: 600 }}>[[ ]]</span> para enlazar pensamientos. Cuando escribes <span style={{ color: C.turquesa, fontWeight: 600 }}>[[</span> se abre un menu con los pensamientos publicos de la comunidad.
          </p>

          {/* Example box */}
          <div style={{
            background: 'rgba(0,0,0,0.4)',
            border: '1px solid rgba(93,193,185,0.3)',
            borderRadius: 16,
            padding: mob ? '20px 16px' : '28px 28px',
            maxWidth: 600,
            margin: '0 auto 20px',
            textAlign: 'left',
          }}>
            <p style={{ fontSize: 10, color: C.turquesa, fontWeight: 600, letterSpacing: 1.5, textTransform: 'uppercase', margin: '0 0 12px' }}>EJEMPLO</p>
            <p style={{ fontFamily: serif, fontSize: mob ? 16 : 20, color: '#fff', lineHeight: 1.6, margin: 0 }}>
              "Estoy entendiendo que <span style={{ color: C.turquesa, textDecoration: 'underline', textDecorationStyle: 'dotted', textUnderlineOffset: 4 }}>[[Cobrar por valor]]</span> aplica mas a servicios que a producto."
            </p>
          </div>

          <p style={{ fontSize: 28, margin: '0 0 16px', color: 'rgba(255,255,255,0.3)' }}>↓</p>

          <p style={{ fontSize: mob ? 14 : 16, color: 'rgba(255,255,255,0.6)', lineHeight: 1.7, maxWidth: 520, margin: '0 auto' }}>
            Se crea una sinapsis entre tu pensamiento y el de la otra persona. Asi nacen las cadenas de pensamiento entre emprendedores que piensan parecido.
          </p>
        </section>

        {/* ═══ 6. TABLA COMPARATIVA ═══ */}
        <section style={{ marginBottom: mob ? 60 : 80 }}>
          <div style={{ textAlign: 'center', marginBottom: 24 }}>
            <span style={{ fontSize: 11, color: C.turquesa, fontWeight: 600, letterSpacing: 2, textTransform: 'uppercase' }}>DIFERENCIA CLAVE</span>
            <p style={{ fontFamily: serif, fontSize: mob ? 22 : 28, fontWeight: 400, margin: '8px 0 0', color: '#fff' }}>Resumen rapido</p>
          </div>

          <div style={{ borderRadius: 20, overflow: 'hidden', border: '0.5px solid rgba(255,255,255,0.1)' }}>
            {/* Header */}
            <div style={{
              display: 'grid', gridTemplateColumns: '1fr 1fr',
              background: 'rgba(255,255,255,0.04)',
            }}>
              <div style={{ padding: mob ? '14px 12px' : '18px 24px', borderRight: '0.5px solid rgba(255,255,255,0.1)', textAlign: 'center' }}>
                <span style={{ fontSize: mob ? 13 : 15, fontWeight: 600, color: C.lila }}>🧠 Ideas Atomicas</span>
              </div>
              <div style={{ padding: mob ? '14px 12px' : '18px 24px', textAlign: 'center' }}>
                <span style={{ fontSize: mob ? 13 : 15, fontWeight: 600, color: C.turquesa }}>🌐 Pensamientos Atomicos</span>
              </div>
            </div>

            {/* Rows */}
            {[
              ['Privadas, solo tu las ves', 'Publicas, las ve toda la comunidad'],
              ['Sobre TU proyecto', 'Sobre TEMAS universales'],
              ['Tu gestor personal', 'La red de T&D'],
              ['Doer $139/mes', 'Free Observer (gratis)'],
              ['Madurar en privado', 'Conectar con otros'],
            ].map((row, i) => (
              <div key={i} style={{
                display: 'grid', gridTemplateColumns: '1fr 1fr',
                borderTop: '0.5px solid rgba(255,255,255,0.06)',
              }}>
                <div style={{ padding: mob ? '14px 12px' : '18px 24px', borderRight: '0.5px solid rgba(255,255,255,0.06)', fontSize: mob ? 13 : 14, color: 'rgba(255,255,255,0.6)', lineHeight: 1.6 }}>
                  {row[0]}
                </div>
                <div style={{ padding: mob ? '14px 12px' : '18px 24px', fontSize: mob ? 13 : 14, color: 'rgba(255,255,255,0.6)', lineHeight: 1.6 }}>
                  {row[1]}
                </div>
              </div>
            ))}
          </div>
        </section>

        {/* ═══ 7. CITA FINAL ═══ */}
        <section style={{ marginBottom: mob ? 48 : 64 }}>
          <div style={{
            background: 'linear-gradient(135deg, #5dc1b9, #FDBE02, #eb636b)',
            borderRadius: 26,
            padding: 4,
          }}>
            <div style={{
              background: C.dark,
              borderRadius: 22,
              padding: mob ? '36px 20px' : '48px 32px',
              textAlign: 'center',
            }}>
              <p style={{
                fontFamily: serif, fontSize: mob ? 24 : 32, fontWeight: 400,
                color: '#fff', lineHeight: 1.4, margin: '0 0 16px', fontStyle: 'italic',
              }}>
                "Piensas en voz baja{mob ? ' ' : <br />}hasta entenderte,{mob ? ' ' : <br />}y el mundo te encuentra."
              </p>
              <p style={{ fontSize: mob ? 14 : 16, color: 'rgba(255,255,255,0.5)', margin: 0 }}>
                Una idea borrosa no conecta con nada — solo la claridad enlaza.
              </p>
            </div>
          </div>
        </section>

        {/* ═══ 8. CTA FINAL ═══ */}
        <div style={{ textAlign: 'center', paddingBottom: 40 }}>
          <button
            onClick={handleCTA}
            style={{
              background: 'linear-gradient(135deg, #5dc1b9, #FDBE02)',
              color: '#0a0a0a',
              border: 'none',
              borderRadius: 50,
              padding: mob ? '16px 36px' : '18px 52px',
              fontSize: mob ? 15 : 17,
              fontWeight: 600,
              cursor: 'pointer',
              fontFamily: font,
              boxShadow: '0 0 40px rgba(93,193,185,0.3)',
              transition: 'transform 0.3s, box-shadow 0.3s',
            }}
            onMouseEnter={e => { e.currentTarget.style.transform = 'translateY(-2px)'; e.currentTarget.style.boxShadow = '0 0 60px rgba(93,193,185,0.5)'; }}
            onMouseLeave={e => { e.currentTarget.style.transform = 'translateY(0)'; e.currentTarget.style.boxShadow = '0 0 40px rgba(93,193,185,0.3)'; }}
          >
            Entrar a Free Observer →
          </button>
        </div>
      </div>

      {/* Styles */}
      <style>{`
        .td-hero-grad {
          background: linear-gradient(135deg, #fff 0%, ${C.lila} 40%, ${C.turquesa} 80%);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
        }
      `}</style>
    </div>
  );
}
